export default __webpack_public_path__ + "static/media/q24_step3.8c26687b.png";